/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const broadcastChannelSchema = z.enum([
	'organisations.{organisation}.payment-methods',
	'organisations.{organisation}.profiles',
	'organisations.{organisation}.subscription',
	'organisations.{organisation}.wallet',
	'organisations.{organisation}.candidate-files',
	'organisations.{organisation}.candidate-profiles',
	'organisations.{organisation}.whatsapp-ai-agent',
	'releases',
])

export type BroadcastChannelSchema = z.infer<typeof broadcastChannelSchema>
